export function hasSendChildRoute(childRoutes, pathname) {
  return childRoutes.some(childRoute => {
    return pathname.includes(childRoute)
  })
}
